import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

/**
 * ScorePercentWithValueLabel displays a bar indicator representing a score
 * percentage, alongside a textual representation of the score.
 *
 * @param {Object} props The properties for the component.
 * @param {number} props.score The score percentage (between 0 and 100) to be displayed.
 * @returns {React.Node} The ScorePercentWithValueLabel component.
 */
export default function ScorePercentWithValueLabel({ score }) {
  const theme = useTheme();

  const progressBarContainerStyles = {
    display: 'flex',
    width: '50%',
    minHeight: '10px',
    mr: 1,
    borderRadius: '10px',
    backgroundColor: theme.palette.grey[400]
  };

  const progressBarStyles = {
    width: `${score}%`,
    minHeight: '10px',
    height: '100%',
    mr: score === 100 ? 0 : 1,
    borderRadius: '10px',
    borderTopRightRadius: score === 100 ? 'inherit' : '0px',
    borderBottomRightRadius: score === 100 ? 'inherit' : '0px',
    borderTopLeftRadius: 'inherit',
    borderBottomLeftRadius: 'inherit',
    backgroundColor: theme.palette.primary.main
  };

  return (
    <MDBox sx={{ display: 'flex', alignItems: 'center', mr: 1, width: '100%' }}>
      <MDTypography
        component="div"
        variant="button"
        sx={{ fontWeight: 'bold', mr: 1, minWidth: 50 }}
      >
        Score :
      </MDTypography>
      <MDBox sx={progressBarContainerStyles}>
        <MDBox sx={progressBarStyles} />
      </MDBox>
      <MDTypography variant="button" fontWeight="regular" sx={{ minWidth: 35 }}>{`${Math.round(
        score
      )}%`}</MDTypography>
    </MDBox>
  );
}

ScorePercentWithValueLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  score: PropTypes.number.isRequired
};
